var map = {
	"./MyPost/components/Consignments.vue": [
		89422,
		422
	],
	"./ParcelContract/components/Consignments.vue": [
		36527,
		527
	],
	"./eParcel/components/Consignments.vue": [
		89347,
		347
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2028;
module.exports = webpackAsyncContext;